const versions = {
    ui: '951301e9dee4a9089813f9efc43c137a28f83d57'
};

export default versions;
